/** Conservative bounds for the selected pinned Lato ASCII watermark contract.
 * Match NoticeFidelityProof.WatermarkLayout; the legacy watermark is unchanged.
 */
export function noticeBrandWatermarkLayout(
  text: string,
  pageSize: 'letter' | 'a4',
  rotation: number,
): { fontSizePt: number; widthPt: number; heightPt: number } {
  const pageWidth = pageSize === 'a4' ? 595.276 : 612;
  const pageHeight = pageSize === 'a4' ? 841.89 : 792;
  const radians = (Math.abs(rotation) * Math.PI) / 180;
  const cosine = Math.cos(radians),
    sine = Math.sin(radians);
  const unitWidth = Math.max(1, text.length) * 1.2;
  const unitHeight = 1.5;
  const fontSizePt = Math.min(
    45,
    (pageWidth - 48) / (unitWidth * cosine + unitHeight * sine),
    (pageHeight - 48) / (unitWidth * sine + unitHeight * cosine),
  );
  return {
    fontSizePt,
    widthPt: unitWidth * fontSizePt,
    heightPt: unitHeight * fontSizePt,
  };
}
